import React, { FC } from 'react';
import styles from './LandscapeIndicatorDescriptionOrganism.module.css';
import cn from 'classnames';
import { Button, ValidationForm } from '../../atoms';
import { Form } from 'react-bootstrap';
import BigInputField from '../../atoms/BigInputField';

export interface LandscapeIndicatorDescriptionOrganismProps {
  description: string;
  setDescription: (content: string) => void;
  callbackFn: () => void;
}

const LandscapeIndicatorDescriptionOrganism: FC<
  LandscapeIndicatorDescriptionOrganismProps
> = ({ description, setDescription, callbackFn }) => {
  return (
    <div className={cn(styles.wrapper)}>
      <ValidationForm onSubmitCallback={callbackFn}>
        <Form.Group className="mb-3 d-flex flex-column">
          <Form.Label>Description</Form.Label>
          <BigInputField content={description} setContent={setDescription} />
        </Form.Group>
        <Button className={cn(styles.button)} variant="dark" type="submit">
          Save
        </Button>
      </ValidationForm>
    </div>
  );
};

export default LandscapeIndicatorDescriptionOrganism;
